<template>
  <v-card flat>
    <v-row justify="center" no-gutters>
      <v-col class="pa-2" cols="12" md="10">
        <v-switch v-model="autoChange" class="mr-5" color="indigo darken-3" hide-details label="تغییر اتوماتیک (محله)"/>
      </v-col>

      <v-col class="pa-2" cols="12" md="10">
        <categoryselector
          ref="category"
          :gradual="true"
          :multiAdsCat="true"
          @category-schema="getSchema"
          @category-fields="getFields"/>
      </v-col>

      <v-col class="pa-2" cols="12" md="10">
        <city-selector :key="autoChange" ref="city" :force="true"/>
      </v-col>

      <v-col class="pa-2" cols="12">
        <own-ads
          v-if="!!myCategory"
          :all="autoChange"
          :category="myCategory"
          :city="schema.advertise.location.city"
          :ladder="true"
          :neighborhood="schema.advertise.location.neighborhood"/>
      </v-col>

      <v-col class="pa-2" cols="12" md="10" style="border-top:1px #7e8299 dashed">
        <v-radio-group v-model="timing" column>
          <v-radio color="indigo" label="تدریجی اتوماتیک: تقسیم آگهی ها بین ساعت شروع تا ساعت پایان" value="auto"/>
          <v-radio color="indigo" label=" تدریجی زماندار: براساس زمان انتخاب شده" value="gradual"/>
        </v-radio-group>
      </v-col>

      <v-col v-if="timing === 'auto'" class="pa-2" cols="12" md="10">
        <v-switch v-model="isDay" class="my-3" color="indigo darken-3" hide-details label="براساس تاریخ"/>

        <div v-for="(item,index) in count" v-if="isDay === true" class="d-flex">
          <multi-times :key="item" :ref="item"/>

          <v-btn class="mx-1 mr-2" color="success" icon outlined small @click="count.push(Math.random())">
            <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
          </v-btn>

          <v-btn v-if="count.length > 1" class="mx-1" color="error" icon outlined small
                 @click="removeDate(index)">
            <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
          </v-btn>
        </div>
        <div v-if="isDay===false" class="py-1">
          <timr-with-days ref="withDays"></timr-with-days>
        </div>
      </v-col>

      <v-col v-if="timing === 'gradual'" class="pa-2" cols="12" md="10">
        <v-switch v-model="isDay" class="my-3" color="indigo darken-3" hide-details label="براساس تاریخ"/>

        <div v-for="(item,index) in count" v-if="isDay === true" class="d-flex">
          <multi-times :key="item" :ref="item" :autoGradual="timing === 'gradual'"/>

          <v-btn class="mx-1 mr-2" color="success" icon outlined small @click="count.push(Math.random())">
            <i class="fa fa-plus text-success" style="font-size: 9pt"></i>
          </v-btn>

          <v-btn v-if="count.length > 1" class="mx-1" color="error" icon outlined small
                 @click="removeDate(index)">
            <i class="fa fa-minus text-danger" style="font-size: 9pt"></i>
          </v-btn>
        </div>

        <div v-if="isDay===false" class="py-1">
          <timr-with-days ref="withDays" :autoGradual="timing === 'gradual'"></timr-with-days>
        </div>
      </v-col>

      <v-col v-if="timing === 'gradual'" class="pa-2" cols="12" md="5">
        <v-text-field v-model.number="newSchema['per']" :rules="[v => !!v || 'این فیلد الزامی است']"
                      append-inner-icon="fa fa-pencil-alt"
                      clear-icon="mdi-close-circle-outline" clearable dense
                      hint="بر اساس دقیقه/از 1 دقیقه تا 120 دقیقه میتوانید درج کنید."
                      label="فاصله زمانی بین هر آگهی (دقیقه)"
                      min="1"
                      oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                      outlined
                      type="number"/>
      </v-col>

      <v-col class="pa-2" cols="12" md="5">
        <v-text-field v-model="newSchema.smart_payload.nickname" clearable dense label="نام مستعار" outlined/>
      </v-col>
    </v-row>

    <v-card-actions class="justify-end">
      <v-btn :loading="loading" class="submit-btn" @click="sendSmartAds(0)">
        <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
        ثبت نردبان تدریجی
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import NumberSelector from "@/view/pages/ads/numberSelector";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import ownAds from "@/view/pages/ads/sendAds/ownAds";
import {Bus} from "@/main";
import MultiTimes from "@/view/pages/ads/sendAds/multiTimes";
import TimrWithDays from "@/view/pages/ads/sendAds/timrWithDays";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
  name: "GradualLadder",

  components: {
    ButtonTempl,
    TimrWithDays,
    MultiTimes,
    SimilarAds,
    TitleRibbon,
    InputMaker,
    AdsSelector,
    Inputs,
    NumberSelector,
    Automatics,
    CitySelector,
    Categoryselector,
    ownAds
  },

  props: {
    divar: {
      required: true
    },
    own: {
      required: true
    },
    ads: {
      required: true
    },
    multi_time: {
      type: Boolean,
      default: false
    },
    pageName: {
      type: String,
      default: "ارسال آگهی هوشمند"
    },
    cats: {
      default: ''
    }

  },

  data() {
    return {
      picker: '',
      timing: 'gradual',
      count: [1],
      autoChange: false,
      requireAds: false,
      ADS: false,
      isSmart: true,
      schema: {
        advertise: {
          location: {
            neighborhood: "",
            city: ''
          },
        },
        available_at: '',
        expire_at: '',
      },
      multiTimes: {},
      newSchema: {
        type: "minute",
        kind: "normal",
        search_payload: {value: 'null'},
        smart_payload: {
          nickname: ''
        },
        count: 1
      },
      myCategory: '',
      isDay: false,
      selected: [],
      loading: false
    }
  },

  mounted() {
    Bus.$on('cityInfo', (value) => {
      this.schema.advertise.location.city = value.city
      if (value.neighborhood === '') {
        delete this.schema.advertise.location.neighborhood;
        delete this.newSchema.smart_payload['neighborhood'];
      } else {
        this.schema.advertise.location.neighborhood = value.neighborhood
        this.newSchema.smart_payload['neighborhood'] = value.neighborhood
      }
    });

    Bus.$on('category-current', (value) => {
      this.myCategory = value
    })
    Bus.$on('selectedAds', (value) => {
      this.newSchema.smart_payload['advertises'] = value
      this.ADS = value.length > 0;
    });

    // Bus.$on("getTimeMode", (value, key) => {
    //     this.multiTimes[key] = value;
    // })
    Bus.$on('getDayMode', (values) => {
      this.newSchema['days'] = values.day;
      this.newSchema['start_time'] = values.start;
      this.newSchema['end_time'] = values.end;
    })
  },

  watch: {
    isDay: {
      handler: function (value) {
        if (value === false) {
          Bus.$on('getDayMode', (values) => {
            this.newSchema['days'] = values.day;
            this.newSchema['start_time'] = values.start;
            this.newSchema['end_time'] = values.end;
          })
        } else if (value === true) {
          delete this.newSchema['days']
          delete this.newSchema['start_time']
          delete this.newSchema['end_time']
          Bus.$on('getTimeMode', (moment) => {
            this.newSchema['expire_at'] = moment.end;
            this.newSchema['start_at'] = moment.started;
            // this.newSchema.smart_payload['repeat'] = moment.repeat;
          })
        }
      }, immediate: true
    },
    timing(val) {
      if (val === "auto")
        this.newSchema.per = -1;
      else
        this.newSchema.per = null;
    },
    autoChange(val) {
      this.newSchema.count = 1;
      // if (val)
      //     delete this.newSchema.count;
      // else
      //     this.newSchema.count = 1;
    }
  },

  methods: {
    getSchema: function (value) {
      this.ui_schema = value;
    },
    getFields: function (val) {
      this.fields = val;
    },
    removeDate(index) {
      this.count.splice(index, 1)
    },
    sendSmartAds(number = 0) {
      const keys = Object.keys(this.multiTimes);

      if (keys.length > 0)
        var param = {
          ...this.newSchema,
          start_at: this.multiTimes[keys[0]].started,
          expire_at: this.multiTimes[keys[0]].end != null ? this.multiTimes[keys[0]].end : undefined
        }

      if (this.ADS === false)
        this.$modal.error('خطا!', 'حداقل یک آگهی از لیست خود را باید انتخاب کنید.')
      else {
        this.loading = true

        $.ajax({
          url: `${url}/smarts`,
          method: 'POST',
          fn: this.sendSmartAds,
          params: [number],

          msg: (number + 1) >= keys.length,
          headers: {
            ACCEPT: 'application/json',
            'Content-Type': 'application/json',
            Authorization: Token
          },
          data: JSON.stringify(keys.length > 0 ? param : this.newSchema),
          success: (data) => {
            this.loading = false
          },
          error: (data) => {
            this.loading = false
          }
        })
          .always(data => {
            number++;
            if (number < keys.length)
              this.sendSmartAds(number);
          });
      }
    }
  }
}
</script>